import {
  Button,
  CircularProgress,
  Drawer,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
  MenuList,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { botActions } from "store/bot";
import { useDispatch, useSelector } from "react-redux";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import ConversationMenu from "components/chat/ConversationMenu";
import { colors } from "colors";
import NewConversationButton from "components/chat/NewConversationButton";
import useIsMobile from "hooks/react-lib/generic-ui/useIsMobile";
import { useTheme } from "@emotion/react";

export default function ConversationDrawerMenu() {
  const isMobile = useIsMobile();
  const theme = useTheme();

  const conversationsState = useSelector((state) => state.conversations);

  const botState = useSelector((state) => state.bot);
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = useState(false);

  if (!isMobile) return null;

  if (conversationsState.error) {
    return null;
  }

  if (!conversationsState.conversations) {
    return null;
  }

  const conversations = conversationsState.conversations;

  const handleSelectConversation = (conversation) => {
    dispatch(botActions.setActiveConversation(conversation));
    setMenuOpen(false);
  };

  return (
    <>
      <IconButton
        onClick={() => setMenuOpen(true)}
        color="white"
        data-testid="main-menu-button"
      >
        <QuestionAnswerIcon />
      </IconButton>
      <Drawer
        data-testid="conversation-menu-drawer"
        open={menuOpen}
        anchor="right"
        onClose={() => setMenuOpen(false)}
        sx={{
          width: "300px",
          "& .MuiDrawer-paper": {
            width: "300px",
            boxSizing: "border-box",
            p: 2,
          },
        }}
      >
        <Stack alignItems="center" justifyContent="center">
          <NewConversationButton
            onCreate={() => setMenuOpen(false)} // Pass callback to close the modal
          />
        </Stack>
        <MenuList
          sx={{
            overflowY: "auto",
          }}
        >
          {conversations.map((conversation, index) => (
            <ListItem
              key={conversation.id}
              secondaryAction={
                <ConversationMenu
                  previousConversation={
                    index === 0 ? null : conversations[index - 1]
                  }
                  nextConversation={
                    index + 1 >= conversations.length
                      ? null
                      : conversations[index + 1]
                  }
                  conversation={conversation}
                  color="text"
                  // color={colors.black}
                />
              }
              selected={conversation.id === botState.activeConversation?.id}
              sx={{
                borderRadius: "4px",
              }}
            >
              <ListItemButton
                onClick={() => handleSelectConversation(conversation)}
              >
                <ListItemText
                  color="text"
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  primary={<Typography>{conversation.subject}</Typography>}
                  secondary={
                    <Typography variant="caption">
                      {new Date(conversation.createdAt).toLocaleString()}
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>
          ))}
        </MenuList>
      </Drawer>
    </>
  );
}
